export const SaveMailingAddressForm = (fields) => {
  return ({
    type: 'GET_MAILING_ADDRESS_DATA',
    payload: { ...fields },
  });
};

export const SelectMailingAddress = (fields) => {
  return ({
    type: 'SELECT_MAILING_ADDRESS',
    payload: fields,
  });
};

export const GetAnotherAddressForm = (fields) => {
  return ({
    type: 'GET_ANOTHER_ADDRESS_DATA',
    payload: fields,
  });
};

export default { SaveMailingAddressForm, SelectMailingAddress };
